import { Box, Button, Chip, Grid, Tooltip, Typography } from "@mui/material";
import CustomCardWithBorder from "../../../components/CustomCardWithBorder";
import { useNavigate } from "react-router-dom";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import BlueSmallButton from "../../../components/customButtons/BlueSmallButton";
import BlueOutlinedSmallButton from "../../../components/customButtons/BlueOutLinedSmallButton";
import ViewAllBlueButton from "../../../components/customButtons/ViewAllBlueButton";
import ScoreCardButton from "../../../components/customButtons/ScoreCardButton";
import Loader from "../../../../SAPPages/components/Loader/Loader";
import { authFetch } from "../../../../api";
import { useState } from "react";
import { color } from "framer-motion";
import DisableBlueSmallButton from "../../../components/customButtons/DisableSmallBlueButton";
import LockIcon from "@mui/icons-material/Lock";
import { TestivaLogin } from "../../testPrepDashboard/Api/TestivaApi";
export default function ExamCards({ exams, subTabName }) {
  const userId = localStorage.getItem("userId");
  const [isExamPortalLoading, setIsExamPortalLoading] = useState(false);

  const navigate = useNavigate();
  if (!exams || exams.length === 0) {
    return <Typography>No exams found.</Typography>;
  }

  // const handleOpenPortalExam = async (examId, examUrl) => {
  //   try {
  //     setIsExamPortalLoading(true);
  //     const requestData = {
  //       user_id: userId,
  //       button_url: examUrl,
  //       exam_id: examId,
  //       // return_url: `${window.location.origin}/performance/my-exam`, //
  //     };

  //     const res = await authFetch("real-test-master/exam-portal-token", {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify(requestData),
  //     });

  //     if (!res.ok) throw new Error("Failed to generate exam token");
  //     const response = await res.json();

  //     const rawUrl = response.data?.exam_url;
  //     if (!rawUrl) throw new Error("No exam URL returned");

  //     const formattedUrl = rawUrl.startsWith("http")
  //       ? rawUrl
  //       : `http://${rawUrl}`;

  //     window.open(formattedUrl, "_blank");
  //   } catch (err) {
  //     console.error(err);
  //     alert("Unable to open exam. Please try again.");
  //   } finally {
  //     setIsExamPortalLoading(false);
  //   }
  // };

  const handleOpenTestivaPortalExam = async (examId, examUrl) => {
    // Open a blank tab immediately (avoids popup blockers)
    const newTab = window.open("", "_blank");

    try {
      setIsExamPortalLoading(true);

      const mobile = localStorage.getItem("mobile");
      console.log("Mobile:", mobile);

      if (!mobile) {
        throw new Error("Mobile number not found in localStorage");
      }

      const requestData = {
        button_url: examUrl,
        exam_id: examId,
        mobile,
      };

      const res = await TestivaLogin({ requestData });

      console.log("Response:", res);
      console.log("Exam URL:", res?.data?.exam_url);

      const rawUrl = res?.data?.exam_url;

      if (!rawUrl) {
        throw new Error(res?.message);
      }

      const formattedUrl = rawUrl.startsWith("http")
        ? rawUrl
        : `https://${rawUrl}`;

      console.log("Opening:", formattedUrl);

      if (newTab) {
        newTab.location.href = formattedUrl;
      } else {
        window.location.href = formattedUrl;
      }
    } catch (err) {
      console.error("Error:", err);

      if (newTab) {
        newTab.close();
      }

      alert(err.message || "Unable to open exam. Please try again.");
    } finally {
      setIsExamPortalLoading(false);
    }
  };

  // Map status to colors (case insensitive)
  const statusMap = {
    "manual checking": { color: "#E65100", backgroundColor: "#E651000D" }, // orange text & light orange bg
    "in progress": { color: "#1E90FF", backgroundColor: "#1E90FF12" }, // blue text & very light blue bg
    "not started": { color: "#999999", backgroundColor: "#F9F9F9" }, // purple text & light purple bg
    "calculating score": { color: "#41810A", backgroundColor: "#E9FFD5" }, // dark green text & light green bg
    completed: { color: "#41810B", backgroundColor: "#E9FFD5" }, // dark green text & light green bg
    "manual evaluation": { color: "#E65100", backgroundColor: "#E651000D" },
    locked: { color: "red", backgroundColor: "#ffeaea" },
  };

  const getDataCardImage = (name) => {
    switch (name) {
      case "Mock":
        return "/newdashboard/performance/Group 1171284044 (4).png";

      case "Listening":
        return "/newdashboard/performance/Group 1171284044 (1).png";

      case "Reading":
        return "/newdashboard/performance/Group 1171284044.png";

      case "Speaking":
        return "/newdashboard/performance/Group 1171284044 (5).png";

      case "Writing":
        return "/newdashboard/performance/Group 1171284044 (3).png";

      case "Grammar":
        return "/images/grammar.png";

      default:
        return "/images/default.png"; // fallback image
    }
  };

  return (
    <>
      {isExamPortalLoading && <Loader text="Loading Test" height="30vh" />}
      <Grid container spacing={2} sx={{ mt: 1 }}>
        {exams.map((exam) => {
          const statusKey = exam.status.toLowerCase();

          // Normalize buttonArray into an array
          const buttons = Array.isArray(exam.buttonArray)
            ? exam.buttonArray
            : exam.buttonArray
              ? [exam.buttonArray]
              : [];
          return (
            <Grid item xs={12} sm={6} md={4} key={exam.id}>
              <CustomCardWithBorder height="100%" boxShadow={true}>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  mb={1}
                >
                  <Box
                    component="img"
                    src={getDataCardImage(subTabName)}
                    alt={subTabName}
                    sx={{ width: 42, mr: 1 }}
                  />
                  <Box
                    py="6px"
                    px="12px"
                    backgroundColor={statusMap[statusKey]?.backgroundColor}
                    borderRadius="8px"
                  >
                    {" "}
                    <Typography
                      fontFamily="Inter"
                      fontWeight={600}
                      fontSize="14px"
                      color={statusMap[statusKey]?.color}
                    >
                      {exam?.status}
                    </Typography>
                  </Box>
                </Box>
                <Typography
                  fontFamily="Inter"
                  fontWeight={600}
                  fontSize="18px"
                  color="#333333"
                >
                  {exam.name}
                </Typography>
                {/* You can add any description if available, else skip */}
                <Typography
                  fontFamily="Inter"
                  fontWeight={400}
                  fontSize="12px"
                  color="#666666"
                >
                  {exam.description}
                </Typography>

                {/* Render one or multiple buttons */}
                <Box
                  mt={2}
                  display="flex"
                  flexDirection="row"
                  justifyContent="space-between"
                  flexWrap="wrap"
                  gap={1}
                >
                  {buttons.map((btn, index) =>
                    exam?.status !== "Locked" ? (
                      btn?.name === "Start Exam" ? (
                        <BlueSmallButton
                          key={index}
                          buttonTitle="Start Exam"
                          startIcon={
                            <img src="/newdashboard/performance/Vector (5).png" />
                          }
                          onClick={() =>
                            handleOpenTestivaPortalExam(exam.hash_id, btn?.url)
                          }
                        />
                      ) : btn?.name === "Resume Exam" ? (
                        <BlueOutlinedSmallButton
                          buttonTitle="Resume Exam"
                          startIcon={
                            <img src="/newdashboard/performance/solar_play-bold.png" />
                          }
                          onClick={() =>
                            handleOpenTestivaPortalExam(exam.hash_id, btn?.url)
                          }
                        />
                      ) : btn?.name === "View Response Sheet" ? (
                        <BlueOutlinedSmallButton
                          key={index}
                          buttonTitle="Response Sheet"
                          startIcon={
                            <img src="/newdashboard/performance/Group.png" />
                          }
                          onClick={() =>
                            handleOpenTestivaPortalExam(exam.hash_id, btn?.url)
                          }
                        />
                      ) : btn?.name === "View Score Card" ? (
                        <ScoreCardButton
                          buttonTitle="Score Card"
                          showEndIcon={true}
                          onClick={() =>
                            handleOpenTestivaPortalExam(exam.hash_id, btn?.url)
                          }
                        />
                      ) : (
                        ""
                      )
                    ) : (
                      <Tooltip
                        title="This test is currently locked. Complete the previous tests to unlock this content."
                        arrow
                      >
                        <span>
                          {" "}
                          <DisableBlueSmallButton
                            buttonTitle="Assessment Locked"
                            height="30px"
                            startIcon={<LockIcon />}
                          />
                        </span>
                      </Tooltip>
                    ),
                  )}
                </Box>

                {exam?.status === "Calculating Score" && (
                  <Typography
                    fontFamily="Inter"
                    fontWeight={400}
                    fontSize="13px"
                    color="#666666"
                  >
                    Calculating Result Please Wait....
                  </Typography>
                )}
              </CustomCardWithBorder>
            </Grid>
          );
        })}
      </Grid>
    </>
  );
}
